import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { ProblemsSection } from '../components/ProblemsSection';
import { SolutionSection } from '../components/SolutionSection';
import { SamplesSection } from '../components/SamplesSection';
import { BonusesSection } from '../components/BonusesSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { ClosingSection } from '../components/ClosingSection';
import { SiteFooter } from '../components/SiteFooter';
import { StickyBuyBar } from '../components/StickyBuyBar';
export function Landing() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-214" data-mp="m7leuzkd0b7d">
      <main data-id="element-215" data-mp="m58y2pqc86vw">
        <Hero data-id="element-216" data-mp="2a0lycb4uw9w" />
        <TrustStrip data-id="element-217" data-mp="2ajtr072k4a7" />
        <ProblemsSection data-id="element-218" data-mp="2b38k81fack0" />
        <SolutionSection data-id="element-219" data-mp="2bbqwfgbea2l" />
        <SamplesSection data-id="element-220" data-mp="3tgbflndtcur7" />
        <BonusesSection data-id="element-221" data-mp="3tg20wvy7ya0t" />
        <OfferSection data-id="element-222" data-mp="3tfjxnfd52vje" />
        <GuaranteeSection data-id="element-223" data-mp="3tift8x1il84o" />
        <FaqSection data-id="element-224" data-mp="3peggmpjcutgl" />
        <ClosingSection data-id="element-225" data-mp="3pdycl6qgbay4" />
      </main>
      <SiteFooter data-id="element-226" data-mp="3pf00ibskfrx9" />
      <StickyBuyBar data-id="element-227" data-mp="3pgkspureqyry" />
    </div>;
}